import * as zod from 'zod';

/**
 * Reason why the teleop step exited.
 * - Completed: Operator stopped teleop normally
 * - Timeout: Step timeout exceeded before teleop was stopped
 * - Error: Teleop entered error state
 * - Interrupted: Step was stopped externally (routine cancelled, emergency stop, etc.)
 */
export const TeleopExitReason = zod.enum([
  'Completed',
  'Timeout',
  'Error',
  'Interrupted',
]);

export type TeleopExitReason = zod.infer<typeof TeleopExitReason>;

export default zod.object({
  /**
   * Current status of the teleop step
   */
  status: zod.enum(['waiting', 'active', 'completed', 'failed']),

  /**
   * Reason why the teleop step exited (only set after completion)
   */
  exitReason: TeleopExitReason.optional(),
});
